module.exports = __webpack_public_path__ + "img/red_044.ccf878f0.png";